import { Brick, registerBrick } from 'olympe';
import { fromJson } from './helpers';

export default class RGCreateColumnConfig extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {number} rank
     * @param {string} propertyPath
     * @param {string} header
     * @param {number} width
     * @param {string} type
     * @param {string|!Object} options
     * @param {boolean} editable
     * @param {boolean} resizable
     * @param {number} level
     * @param {function(!Object)} setObject
     */
    update(_$, [rank, propertyPath, header, width, type, options, editable, resizable, level], [setObject]) {
        setObject({
            Rank: rank,
            'Property Path': propertyPath,
            Header: header,
            Width: width,
            Type: type,
            Options: fromJson(options)[0],
            Editable: editable,
            Resizable: resizable,
            Level: level
        });
    }
}

registerBrick('01921d9038d9eb72f609', RGCreateColumnConfig);
